import AnalyzePerformanceChartWrapper from "./AnalyzePerformanceChartWrapper";
import "./AnalyzePerformanceChartWrapper.scss";

export default AnalyzePerformanceChartWrapper